<template>
    <IQOS :title="$t('subscription.transactions.title')" class="iqos-long mr-0" boxClass="container-box p-0">
      <div class="bills-box">
        <table class="table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">{{$t('subscription.transactions.date')}}</th>
              <th scope="col">{{$t('subscription.transactions.time')}}</th>
              <th scope="col">{{$t('subscription.transactions.system')}}</th>
              <th scope="col">{{$t('subscription.transactions.method')}}</th>
              <th scope="col">{{$t('subscription.transactions.sum')}}</th>
              <th scope="col">{{$t('subscription.transactions.commission')}} (%)</th>
              <th scope="col">{{$t('subscription.transactions.commission')}} ({{$t('stats.currency.uahn')}})</th>
              <th scope="col">{{$t('subscription.transactions.balance')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in transactions" :key="item._id">
              <td>
                <img src="/icons/transaction-income.svg" v-if="item.amount > 0" />
                <img src="/icons/transaction-outcome.svg" v-if="item.amount < 0" />
              </td>
              <td>{{ item.created_at | formatDate }}</td>
              <td>{{ item.created_at | formatTime }}</td>
              <td>
                <span :class="item.mode" v-if="item.mode">{{ item.mode.toUpperCase() }}</span>
              </td>
              <td>
                <div v-if="item.amount < 0">
                  <span v-if="item.pay_method == 'cash'">{{$t('subscription.transactions.cash')}}</span>
                  <span v-if="item.pay_method == 'card'">{{$t('subscription.transactions.terminal')}}</span>
                  <span v-if="item.pay_method == 'online'">{{$t('subscription.transactions.online')}}</span>
                </div>
              </td>
              <td>{{ item.total }} грн</td>
              <td><span v-if="item.amount < 0"> {{ item.comission }}%</span></td>
              <td><span v-if="item.amount < 0">{{ item.amount}} грн</span></td>
              <td>{{ item.balance }} грн</td>
            </tr>
            <!-- <tr v-for="(payment,index) in payments" :key="index">
              <td>{{ payment.banking_id }}</td>
              <td>{{ payment.date | formatDatetime }}</td>
              <td>{{ payment.card_type }} {{ payment.card_mask }}</td>
              <td>{{ (payment.plan || 'N/A') | capitalize}}</td>
              <td>{{ payment.periodicity == 'year' ? '1 рік' : '1 місяць' }}</td>
              <td>{{ payment.amount }} {{ payment.currency }}</td>
              <td>
                <span class="c-green" v-if="payment.status == 'success'">
                  Успішний
                </span>
                <span class="c-red" v-else-if="payment.status == 'failure'">
                  Помилка
                </span>
                <span class="c-yellow" v-else>
                  {{ payment.status }}
                </span>
              </td>
            </tr>-->
          </tbody>
        </table>
      </div>
    </IQOS>
</template>

<style scoped>
 
th {
  text-align: center;
  color: #a4a3a1;
}

.bills-box {
  width: 122vh;
}

.table th {
  border-top: 0 !important;
}

thead th {
  position: sticky;
  top: 0;
  background: #1d1d1d;
}

td {
  text-align: center;
  color: #ededed;
}

td img {
  height: 3vh;
  width: auto;
}

/* td span {
  color: #ededed;
  font-size: 1.8vh;
  background: #262626;
} */

td span.preorder {
  background: #ffd2a8;
  border-radius: 0.7vh;
  color: #1d1d1d;
  padding: 0.5vh 1vh;
}

td span.delivery {
  background: #cbd9e6;
  border-radius: 0.7vh;
  color: #1d1d1d;
  padding: 0.5vh 1vh;
}

td span.reserve {
  background: #AECCC6;
  border-radius: 0.7vh;
  color: #1d1d1b;
  padding: 0.5vh 1vh;
}

.text-red {
  color: #e2223b;
}
.text-green {
  color: #129b81;
}

.table th {
  padding: 1.5vh;
}

th,
td {
  font-size: 2vh;
}

.bills-container {
  width: 100%;
  padding-right: 5.5vh;
}
</style>

<script>
import IQOS from "@/components/IQOS.vue";
import BlackInput from "@/components/BlackInput.vue";

import BillingAPI from "@/api/billing";

export default {
  data() {
    return {
      transactions: []
    };
  },
  components: {
    IQOS,
    BlackInput
  },
  computed: {
    subscription() {
      return this.$store.state.subscription;
    },
    payments() {
      if (!this.subscription) return [];

      return this.subscription.payments;
    }
  },
  methods: {
    fetchData() {
      BillingAPI.getTransactions()
        .then(data => {
          this.transactions = data.transactions;
        })
        .catch(error => {
          this.$store.dispatch("showError", "billing_fetch");
        });
    }
  },
  mounted() {
    this.fetchData();
  },
  filters: {
    capitalize(str) {
      return str.substring(0, 1).toUpperCase() + str.substring(1);
    }
  }
};
</script>